<template>
<loader v-bind="{ loading }">
  <columns>
    <column class="is-8">
      <columns>
        <column>
          <flex class="justify-between">
            <h4 class="title is-marginless">
              <span class="has-text-secondary">
                <span v-if="route.uri !== '/'">/</span><span>{{ `${route.uri}` }}</span>
              </span><br>
              <span class="help">
                Last Updated {{ route.updated_at | asCalendar }}
              </span>
            </h4>
            <icon icon="times" class="has-text-danger"/>
          </flex>
        </column>
      </columns>

      <columns>
        <column class="is-narrow">
          <span class="tags has-addons is-rounded">
            <span class="tag is-rounded">Method</span>
            <span class="tag is-rounded" :class="{
              'is-info': route.method === 'GET',
              'is-warning': route.method === 'POST' || route.method === 'PUT',
              'is-danger': route.method === 'DELETE',
            }">{{ route.method }}</span>
          </span>
        </column>
        <column class="is-narrow" v-tooltip="route.controller">
          <span class="tags has-addons is-rounded">
            <span class="tag is-rounded">Controller</span>
            <span class="tag is-info is-rounded">{{ controllerName }}</span>
          </span>
        </column>
        <column class="is-narrow">
          <span class="tags has-addons is-rounded">
            <span class="tag is-rounded">Action</span>
            <span class="tag is-info is-rounded">{{ route.action }}</span>
          </span>
        </column>
      </columns>

      <columns>
        <column>
          <h3 class="title is-5">Findings ({{ route.findings.length }})</h3>
          <finding 
            v-for="finding in route.findings" 
            :key="finding.id"
            :finding="finding"
          />
        </column>
      </columns>
    </column>
    <column>
      <form-request v-if="route.method !== 'GET'" class="box"/>
      <bindings class="box"/>
      <middleware class="box"/>
      <headers class="box"/>
    </column>
  </columns>
</loader>  
</template>
<script>
import FormRequest from './partials/FormRequest'
import Bindings from './partials/Bindings'
import Middleware from './partials/Middleware'
import Headers from './partials/Headers'
import { mapGetters } from 'vuex'
import { falsePositive } from '@/modals'
import { last } from 'lodash'
import Finding from './partials/Finding.vue'

export default {

  components: {
    FormRequest,
    Bindings,
    Middleware,
    Headers,
    Finding
  },
  
  data: () => ({
    loading: true
  }),

  beforeCreate() {
    this.$store.dispatch('route/loadRoute', this.$route.params.route).then(() => {
      this.loading = false
    })
  },

  methods: {
    markAsFalsePositive(finding) {
      falsePositive(finding).then(falsePositive => {
        if(falsePositive) {
          this.$store.commit('route/setFalsePositiveOnFinding', {
            findingId: finding.id,
            falsePositive
          })
        }
      })
    }
  },

  computed: {
    ...mapGetters('route', [
      'route'
    ]),
    controllerName() {
      const parts = this.route.controller.split('\\')
      return last(parts) + '.php'
    },
    groupedFindings() {
      return this.route.findings
    }
  }

}
</script>